export const locale = {
  'ROWOPERATION' : {
    'SHOWONMAP' : 'Показать на карте',
    'DOWNLOADTRACK' : 'Скачать трек',
    'DISBAND' : 'Освободить грузовик',
  }
};
